import { normalizarTexto } from '../lib/textoBR'

// O formato do alvo de fabricante mora AQUI, e so aqui. O motor, a tela da
// regra e a tela de Produtos consomem estas funcoes -- se cada uma montasse a
// string a mao, elas discordariam sobre o que e "o mesmo fabricante", e a
// discordancia pagaria dinheiro errado. E a licao do bug de 26/08.
export const PREFIXO_FABRICANTE = 'fabricante:'

// Grava o nome CRU, como ela digitou. A normalizacao acontece so na LEITURA,
// em mesmoFabricante: gravar normalizado faria a tela mostrar "mauri" onde ela
// escreveu "MAURI", e mudaria alvos ja gravados se a normalizacao mudasse.
export function alvoDeFabricante(nome: string): string {
  return `${PREFIXO_FABRICANTE}${nome.trim()}`
}

export function nomeDoAlvoFabricante(alvo: string): string | null {
  if (!alvo.startsWith(PREFIXO_FABRICANTE)) return null
  return alvo.slice(PREFIXO_FABRICANTE.length)
}

// ⚠ Ausente NUNCA casa, nem com outro ausente: dois produtos sem fabricante nao
// sao "do mesmo fabricante", e trata-los assim faria uma regra de fabricante
// pegar todo produto em branco da marca.
export function mesmoFabricante(
  a: string | null | undefined,
  b: string | null | undefined,
): boolean {
  if (!a || !b) return false
  const na = normalizarTexto(a)
  const nb = normalizarTexto(b)
  if (na === '' || nb === '') return false
  return na === nb
}

// Um nome por fabricante, juntando caixas diferentes. Mostra a PRIMEIRA grafia
// encontrada -- mostrar as duas faria ela criar duas regras achando que sao
// fabricantes distintos.
export function fabricantesDistintos(
  produtos: Array<{ fabricante?: string | null }>,
): string[] {
  const porChave = new Map<string, string>()
  for (const p of produtos) {
    const nome = p.fabricante?.trim()
    if (!nome) continue
    const chave = normalizarTexto(nome)
    if (chave === '') continue
    if (!porChave.has(chave)) porChave.set(chave, nome)
  }
  return [...porChave.values()].sort((a, b) => a.localeCompare(b, 'pt-BR'))
}

// As opcoes do seletor de fabricante da tela de Produtos.
//
// ⚠ O fabricante que ESTA filtrando entra na lista mesmo que nao exista mais
// entre os produtos visiveis -- por exemplo, depois de ela trocar a fornecedora.
// Sem isso o seletor sumiria com o filtro ainda ligado: lista vazia, sem nenhum
// jeito visivel de voltar para "Todos os fabricantes".
export function opcoesDeFabricante(fabricantes: string[], filtroAtual: string): string[] {
  if (!filtroAtual.trim()) return fabricantes
  if (fabricantes.some((f) => mesmoFabricante(f, filtroAtual))) return fabricantes
  return [filtroAtual, ...fabricantes]
}

// A regra ja tem percentual para este fabricante?
//
// ⚠ Duas grafias do mesmo fabricante na MESMA regra casariam com o mesmo
// produto, e qual venceria seria a ordem do `find` -- sorteio pagando dinheiro.
// Acontece de verdade: a regra nasce com a grafia de hoje e a fabrica manda a
// planilha seguinte com outra. Entre regras diferentes nao ha conflito --
// escolherRegra ja decide qual regra vale para a tabela.
export function jaTemPercentualDeFabricante(
  percentuais: Array<{ alvo: string }>,
  nome: string,
): boolean {
  return percentuais.some((p) => {
    const existente = nomeDoAlvoFabricante(p.alvo)
    return existente !== null && mesmoFabricante(existente, nome)
  })
}
